import React, { useState, useEffect, useCallback } from "react";

import moon from "../assets/moon.png";
import sun from "../assets/sun.png";
import { postUISettingsToIframe } from "../functions/chatBotUiSettings";

function Theme() {
  const prefersDarkMode = () => {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    );
  };

  const [isDarkTheme, setIsDarkTheme] = useState(prefersDarkMode());

  const handleClick = () => {
    const newTheme = !isDarkTheme;
    setIsDarkTheme(newTheme);
    postUISettingsToIframe({ theme: newTheme ? "dark" : "light" });
  };

  const updateTheme = useCallback(() => {
    const root = document.documentElement;
    const nextTheme = isDarkTheme ? "dark" : "light";

    root.setAttribute("data-bs-theme", nextTheme);
  }, [isDarkTheme]);

  useEffect(() => {
    updateTheme();
  }, [isDarkTheme, updateTheme]);

  return (
    <div
      className="fixed-bottom d-flex justify-content-end"
      style={{
        pointerEvents: "none",
        right: "calc(24px + 100px + 48px)",
        bottom: "10px",
        zIndex: 10,
      }}
    >
      <img
        src={isDarkTheme ? sun : moon}
        onClick={handleClick}
        title="Change theme"
        alt="theme"
        width="50px"
        height="50px"
        className="m-3"
        style={{ pointerEvents: "auto"}}
      />
{/*      <ChatBot></ChatBot>*/}
    </div>
  );
}

export default Theme;
